module.exports = __webpack_public_path__ + "ipetbooking/admin/img/fbCode_n1.e426b014.png";